const all_orders = [
    {
        id: "#1236",
        date: "1 Nov, 10:20 AM",
        email: "michael.lawson@reqres.in",
        first_name: "Michael",
        last_name: "Lawson",
        avatar: "https://reqres.in/img/faces/7-image.jpg",
        product: "Phone Case Pink  x 2",
        price: "50,00",
        status: "Paid"
    },
    {
        id: "#1235",
        date: "1 Nov, 10:20 AM",
        email: "lindsay.ferguson@reqres.in",
        first_name: "Lindsay",
        last_name: "Ferguson",
        avatar: "https://reqres.in/img/faces/8-image.jpg",
        product: "Valvet T-shirt",
        price: "55,50",
        status: "Canceled"
    },
    {
        id: "#1234",
        date: "1 Nov, 10:20 AM",
        email: "tobias.funke@reqres.in",
        first_name: "Tobias",
        last_name: "Funke",
        avatar: "https://reqres.in/img/faces/9-image.jpg",
        product: "Nike Sport V2",
        price: "140,20",
        status: "Paid"
    },
    {
        id: "#1233",
        date: "1 Nov, 10:20 AM",
        email: "byron.fields@reqres.in",
        first_name: "Byron",
        last_name: "Fields",
        avatar: "https://reqres.in/img/faces/10-image.jpg",
        product: "Nike Sport V2",
        price: "140,20",
        status: "Refunded"
    },
    {
        id: "#1232",
        date: "1 Nov, 10:20 AM",
        email: "george.edwards@reqres.in",
        first_name: "George",
        last_name: "Edwards",
        avatar: "https://reqres.in/img/faces/11-image.jpg",
        product: "Nike Sport V2",
        price: "140,20",
        status: "Canceled"
    },
    {
        id: "#1231",
        date: "1 Nov, 10:20 AM",
        email: "rachel.howell@reqres.in",
        first_name: "Rachel",
        last_name: "Howell",
        avatar: "https://reqres.in/img/faces/12-image.jpg",
        product: "Nike Sport V2",
        price: "140,20",
        status: "Paid"
    },
    {
        id: "#1236",
        date: "1 Nov, 10:20 AM",
        email: "michael.lawson@reqres.in",
        first_name: "Michael",
        last_name: "Lawson",
        avatar: "https://reqres.in/img/faces/7-image.jpg",
        product: "Phone Case Pink  x 2",
        price: "50,00",
        status: "Paid"
    },
    {
        id: "#1235",
        date: "1 Nov, 10:20 AM",
        email: "lindsay.ferguson@reqres.in",
        first_name: "Lindsay",
        last_name: "Ferguson",
        avatar: "https://reqres.in/img/faces/8-image.jpg",
        product: "Valvet T-shirt",
        price: "55,50",
        status: "Canceled"
    },
    {
        id: "#1234",
        date: "1 Nov, 10:20 AM",
        email: "tobias.funke@reqres.in",
        first_name: "Tobias",
        last_name: "Funke",
        avatar: "https://reqres.in/img/faces/9-image.jpg",
        product: "Nike Sport V2",
        price: "140,20",
        status: "Paid"
    },
    {
        id: "#1233",
        date: "1 Nov, 10:20 AM",
        email: "byron.fields@reqres.in",
        first_name: "Byron",
        last_name: "Fields",
        avatar: "https://reqres.in/img/faces/10-image.jpg",
        product: "Nike Sport V2",
        price: "140,20",
        status: "Refunded"
    },
    {
        id: "#1232",
        date: "1 Nov, 10:20 AM",
        email: "george.edwards@reqres.in",
        first_name: "George",
        last_name: "Edwards",
        avatar: "https://reqres.in/img/faces/11-image.jpg",
        product: "Nike Sport V2",
        price: "140,20",
        status: "Canceled"
    },
    {
        id: "#1231",
        date: "1 Nov, 10:20 AM",
        email: "rachel.howell@reqres.in",
        first_name: "Rachel",
        last_name: "Howell",
        avatar: "https://reqres.in/img/faces/12-image.jpg",
        product: "Nike Sport V2",
        price: "140,20",
        status: "Paid"
    }
]

export default all_orders;